import { render, staticRenderFns } from "./StockControlRecordGeneralInfo.vue?vue&type=template&id=105b9b36&"
import script from "./StockControlRecordGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./StockControlRecordGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QSelect,QSeparator,QInput,QBanner,QIcon,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QItem,QSelect,QSeparator,QInput,QBanner,QIcon,QInnerLoading,QSpinnerGears}, component.options.components || {})
